import Logo from "../../images/Logo.png";

function Footer() {
  return (
    <footer className="bg-[#4B4848] pt-16 pb-4 text-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap gap-8">
          <div className="flex-1 min-w-[200px]">
            <img src={Logo} alt="Qbicles Logo" className="w-36 h-auto" />
          </div>

          <div className="flex-[3] flex flex-wrap gap-8">
            <div className="flex-1 min-w-[200px]">
              <h4 className="text-white font-semibold text-lg mb-4">
                Contact Us
              </h4>
              <p className="mb-2">Atoms Interactive Limited</p>
              <p className="mb-2">27 Balarabe Musa Crescent</p>
              <p className="mb-2">V.I. Lagos, Nigeria</p>
              <a
                href="mailto:hello@qbicles.com"
                className="text-gray-300 hover:text-blue-300 transition-colors"
              >
                hello@qbicles.com
              </a>
            </div>

            {/* <div className="flex-1 min-w-[200px]">
                            <h4 className="text-white font-semibold text-lg mb-4">About Us</h4>
                            <p className="text-gray-300">Learn more about our mission and values</p>
                        </div> */}

            {/* <div className="flex-1 min-w-[200px]">
                            <h4 className="text-white font-semibold text-lg mb-4">Related Products</h4>
                            <ul className="space-y-2">
                                <li>
                                    <a href="#" className="text-gray-300 hover:text-blue-300 transition-colors">
                                        Qbicles Retail
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="text-gray-300 hover:text-blue-300 transition-colors">
                                        Moniback
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="text-gray-300 hover:text-blue-300 transition-colors">
                                        BankMate
                                    </a>
                                </li>
                            </ul>
                        </div> */}
          </div>
        </div>

        <div className="mt-12 pt-4 border-t border-gray-600 text-center">
          <p className="text-gray-300">
            &copy; {new Date().getFullYear()} Qbicles. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
